"use client";

import Button from "@/components/ui/Button";
import { useModal } from "@/hooks/useModal";
import type { ProductCard as PC } from "@/lib/centra/formatters/formatProductCards/formatProductCard";
import useSizes from "@/lib/centra/hooks/useSizes";
import { useAddToCart } from "@frend-digital/centra/client";

const ProductCardActions = ({ product }: { product: PC }) => {
  const sizes = product?.description?.size;
  const newSizes = useSizes(sizes);
  const { mutate: addToCart } = useAddToCart();
  const { toggleModal } = useModal("cart", { lock: true });

  const addToCartHandler = () => {
    if (!newSizes?.selectedSize) return false;
    if (newSizes?.selectedSize?.itemId)
      addToCart(
        {
          itemId: newSizes?.selectedSize?.itemId,
        },
        {
          onSuccess: selection => {
            toggleModal();
          },

          onError: error => {
            debugger;
          },
        },
      );
  };

  return (
    <Button onClick={addToCartHandler} full>
      Add to cart
    </Button>
  );
};

export default ProductCardActions;
